// 合同电签
export const dqRoutes = [
  // 合同电签+
  {
    path: '/dq_dev/auth',
    name: 'dq_dev',
    meta: { title: '跳转中...' },
    component: () => import('@/views/dq/auth.vue'),
  },
  {
    path: '/dq/auth',
    name: 'dq_auth',
    meta: { title: '跳转中...' },
    component: () => import('@/views/dq/auth.vue'),
  },
  {
    path: '/dq/login',
    name: 'dq_login',
    meta: { title: '登录' },
    component: () => import('@/views/dq/Login.vue'),
  },
  {
    path: '/dq/agreement',
    name: 'dq_agreement',
    meta: { title: '协议' },
    component: () => import('@/views/dq/Agreement.vue'),
  },
  {
    path: '/dq/regist',
    name: 'dq_regist',
    meta: { title: '个体商户入驻' },
    component: () => import('@/views/dq/Regist.vue'),
  },
  {
    path: '/dq/bankList',
    name: 'bank_list',
    meta: { title: '选择开户行' },
    component: () => import('@/views/dq/BankList.vue'),
  },
  {
    path: '/dq/registSuccess',
    name: 'registSuccess',
    meta: { title: '注册成功' },
    component: () => import('@/views/dq/RegistSuccess.vue'),
  },
  {
    path: '/dq/agreementList',
    name: 'agreement_list',
    meta: { title: '商户合同签署' },
    component: () => import('@/views/dq/AgreementList.vue'),
  },
  {
    path: '/dq/guide',
    name: 'guide',
    meta: { title: '请在浏览器中打开' },
    component: () => import('@/views/dq/GuidePage.vue'),
  },
  {
    path: '/dq/guide_phone',
    name: 'guide_phone',
    meta: { title: '请在浏览器中打开' },
    component: () => import('@/views/dq/GuidePage_Phone.vue'),
  },
  {
    path: '/dq/business_choice',
    name: 'business_choice',
    meta: { title: '选择登录商户' },
    component: () => import('@/views/dq/business/choice.vue'),
  },
  {
    path: '/dq/business_sign',
    name: 'business_sign',
    meta: { title: '商户合同管理' },
    component: () => import('@/views/dq/business/sign.vue'),
  },
  {
    path: '/dq/change_user',
    name: 'change_user',
    meta: { title: '更换印章保管员' },
    component: () => import('@/views/dq/business/change-user.vue'),
  },
];
